import { getPromise, postPromise, patchPromise } from '../Promise';

export default class Auth {
  static login(user) {
    return postPromise('/users/login', user);
  }

  static fetchSelf() {
    return getPromise('/me');
  }

  static logout() {
    return postPromise('/users/logout');
  }

  async getDetails() {
    return await getPromise('/me');
  }

  requestResetPassword(user) {
    return postPromise('/users/forgot-password/email', user);
  }

  resetPassword(user) {
    return postPromise(`/password/reset?token=${user.token}`, user);
  }

  verify(user) {
    return postPromise(
      `/email/verify?email=${user.email}&expires=${user.expires}&signature=${user.signature}`,
      user
    );
  }

  changePassword(user) {
    return postPromise('/users/' + user.id + '/change-password', user);
  }

  updateProfile(user) {
    return patchPromise('/users/' + user.id, user);
  }

  confirmInvitation(user) {
    return postPromise('/users/invitation/confirm', user);
  }
}
